export default {
  data: function () {
    return {};
  },
  computed: {
    userSubscription() {
      return this.$store.getters.currentUserSubscription;
    }
  }
};